import type { ReactNode } from 'react';
import { EmptyState } from '@/shared/components';

/** Das gewählte Apartment liegt nicht im geladenen Ausschnitt (Rechte, Objektauswahl, Filter). */
export function MonthApartmentMissing() {
  return (
    <section className="bg-card border-hairline rounded-tile shadow-float border">
      <EmptyState
        icon="Building"
        title="Dieses Apartment ist hier nicht sichtbar."
        description="Wähle oben ein anderes Apartment oder geh zurück zum Grundkalender."
      />
    </section>
  );
}

/** Desktop: Raster und Seitenleiste nebeneinander, die Leiste nur mit Edit oder Tagesdetail. */
export function MonthDesktopLayout({
  grid,
  side,
  canEdit,
}: {
  grid: ReactNode;
  side: ReactNode | null;
  canEdit: boolean;
}) {
  return (
    <div className="flex flex-wrap items-start gap-4">
      {grid}
      {side && (
        <aside
          aria-label={canEdit ? 'Zeitraum bearbeiten' : 'Tagesdetail'}
          className="bg-card border-hairline rounded-tile shadow-float flex min-w-0 max-w-[440px] flex-[1_1_360px] flex-col border"
        >
          {side}
        </aside>
      )}
    </div>
  );
}
